export enum TreeMode {
  NoSelect,
  SingleSelect,
  MultiSelect,
  HideSelected
}
